/**
 * @desc 查看用户角色
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<defs.appCenter.AppDomainRoleUserResponseDto>;
export function request(userCode: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/role/permission/user/${userCode}`, {
      method: "GET",

      ...options,
    }),
  );
}
